// BE vbdt — VBDT/Controllers/UserController.cs
export const apiUser = '/api/users'
export const apiUserCombobox = '/api/users/combobox'
export const apiUserProfile = '/api/users/profile'
export const apiUserProfileAvatar = '/api/users/profile/avatar'
export const apiUserById = (id: string) => `/api/users/${id}`
export const apiUserAvatar = (id: string) => `/api/users/${id}/avatar`
export const apiUserLock = (id: string) => `/api/users/${id}/lock`
export const apiUserUnlock = (id: string) => `/api/users/${id}/unlock`
export const apiUserResetPassword = (id: string) => `/api/users/${id}/reset-password`
export const apiUserBulkDelete = '/api/users/bulk-delete'
export const apiUserBulkLock = '/api/users/bulk-lock'
export const apiUserBulkUnlock = '/api/users/bulk-unlock'
export const apiUserLogout = (id: string) => `/api/users/${id}/logout`
export const apiUserBulkLogout = '/api/users/bulk-logout'
export const apiUserDepartmentPositionCombobox = '/api/users/department-position-combobox'

// Chức vụ của người dùng — route riêng `api/users` (số nhiều), khác `api/user` (số ít) ở trên.
// Đúng như contract được giao, chưa xác nhận lại với BE — xem báo cáo cuối T23.
